import { render } from "./FormItem.vue?vue&type=template&id=33c1b252"
import script from "./FormItem.vue?vue&type=script&lang=js"
export * from "./FormItem.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/bambl/V3/v2026.6.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__